module.exports = __webpack_public_path__ + "img/image11.a1ba333f.jpg";